import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-committee', templateUrl: './committee.component.html', styleUrls: ['./committee.component.scss'] })
export class CommitteeComponent implements OnInit { constructor() { } ngOnInit(): void { } }
